import { Component } from '@angular/core';

@Component({
  selector: 'app-invalid-file',
  templateUrl: './invalid-file.component.html',
  styleUrls: ['./invalid-file.component.scss'],
  standalone: false
})
export class InvalidFileComponent {}
